<template>
  <div class="modal fade" id="notaContabilaModal" tabindex="-1" aria-hidden="true" ref="modal">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-light-primary text-primary">
          <h2 class="modal-title fw-bold text-primary">{{ form.id ? 'Editează Notă Contabilă' : 'Adaugă Notă Contabilă' }}</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <div class="row g-4 mb-5">
            <div class="col-md-3">
              <label class="form-label required">Data Document</label>
              <input type="date" class="form-control" v-model="form.doc_data" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Nr. Document</label>
              <input type="text" class="form-control" placeholder="Ex: NC001" v-model="form.doc_numar" />
            </div>
          </div>

          <h4 class="mb-3">Linii Notă Contabilă</h4>
          <div class="table-responsive">
            <table class="table table-bordered align-middle table-hover">
              <thead class="table-light">
                <tr>
                  <th>Explicație</th>
                  <th style="width: 25%;">Cont Debit</th>
                  <th style="width: 25%;">Cont Credit</th>
                  <th style="width: 15%;">Suma (RON)</th>
                  <th style="width: 50px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(linie, index) in form.linii" :key="index">
                  <td>
                    <input type="text" class="form-control form-control-sm" v-model="linie.explicatie" placeholder="Explicație linie" />
                  </td>
                  <td>
                    <multiselect
                      v-model="linie.cont_debit_obj"
                      :options="conturi"
                      track-by="id"
                      label="cod_complet"
                      :custom-label="contLabel"
                      placeholder="Alege..."
                      class="w-100 small-text-multiselect"
                      :searchable="true"
                      :loading="loadingConturi"
                      :max-height="210"
                      select-label=""
                      selected-label=""
                      deselect-label=""
                      @select="(opt) => linie.cont_debit_id = opt.id"
                    >
                    </multiselect>
                  </td>
                  <td>
                    <multiselect
                      v-model="linie.cont_credit_obj"
                      :options="conturi"
                      track-by="id"
                      label="cod_complet"
                      :custom-label="contLabel"
                      placeholder="Alege..."
                      class="w-100 small-text-multiselect"
                      :searchable="true"
                      :loading="loadingConturi"
                      :max-height="210"
                      select-label=""
                      selected-label=""
                      deselect-label=""
                      @select="(opt) => linie.cont_credit_id = opt.id"
                    >
                    </multiselect>
                  </td>
                  <td>
                    <input type="number" class="form-control form-control-sm text-end" v-model.number="linie.suma_ron" min="0.01" step="0.01" />
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-sm btn-icon btn-light-danger" @click="stergeLinie(index)" v-if="form.linii.length > 1">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4">
                    <button type="button" class="btn btn-sm btn-light-primary" @click="adaugaLinie">
                      <i class="fa fa-plus me-1"></i> Adaugă Rând Nou
                    </button>
                  </td>
                  <td></td>
                </tr>
                <tr class="fw-bold bg-light">
                  <td colspan="3" class="text-end">Total Sumă:</td>
                  <td class="text-end text-primary">{{ formatMoney(totalSuma) }}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="closeModal">Renunță</button>
          <button type="button" class="btn btn-primary" @click="salveazaNota" :disabled="loading || !isValid">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            <i v-else class="fa fa-save me-1"></i>
            Salvează Nota
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2'

export default {
  name: 'NotaContabilaModal',
  components: {
    Multiselect
  },
  props: {
    firmaId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      modalInstance: null,
      loading: false,
      loadingConturi: false,
      conturi: [],
      form: {
        id: null,
        doc_data: new Date().toISOString().split('T')[0],
        doc_numar: '',
        linii: [
          {
            explicatie: '',
            cont_debit_id: '',
            cont_debit_obj: null,
            cont_credit_id: '',
            cont_credit_obj: null,
            suma_ron: 0,
          }
        ]
      }
    };
  },
  computed: {
    totalSuma() {
      return this.form.linii.reduce((sum, linie) => sum + (parseFloat(linie.suma_ron) || 0), 0);
    },
    isValid() {
      if (!this.form.doc_data) return false;
      for (const linie of this.form.linii) {
        if (!linie.cont_debit_obj || !linie.cont_credit_obj || !linie.suma_ron || linie.suma_ron <= 0) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    firmaId: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.fetchConturi();
      }
    }
  },
  mounted() {
    if (window.bootstrap && this.$refs.modal) {
      this.modalInstance = new window.bootstrap.Modal(this.$refs.modal);
    }
  },
  methods: {
    formatMoney(v) {
      return Number(v || 0).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    showModal() {
      this.resetForm();
      if (this.modalInstance) {
        this.modalInstance.show();
      }
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    resetForm() {
      this.form = {
        id: null,
        doc_data: new Date().toISOString().split('T')[0],
        doc_numar: '',
        linii: [
          { explicatie: '', cont_debit_id: '', cont_debit_obj: null, cont_credit_id: '', cont_credit_obj: null, suma_ron: 0 }
        ]
      };
      this.loading = false;
    },
    adaugaLinie() {
      // prefill explicatie based on previous row if available
      const prev = this.form.linii[this.form.linii.length - 1];
      this.form.linii.push({
        explicatie: prev ? prev.explicatie : '',
        cont_debit_id: '',
        cont_debit_obj: null,
        cont_credit_id: '',
        cont_credit_obj: null,
        suma_ron: 0
      });
    },
    stergeLinie(index) {
      this.form.linii.splice(index, 1);
    },
    async fetchConturi() {
      this.loadingConturi = true;
      try {
        const res = await axios.get('/api/contabilitate/plan_conturi', {
          params: { id_firma: this.firmaId }
        });
        this.conturi = res.data;
      } catch (e) {
        console.error("Nu s-au putut obține conturile pentru nota contabilă", e);
      }
      this.loadingConturi = false;
    },
    contLabel(option) {
        return `${option.cod_complet} | ${option.descriere || ''}`
    },
    async salveazaNota() {
      if (!this.isValid) {
        Swal.fire("Atenție", "Completați corect toate câmpurile obligatorii.", "warning");
        return;
      }
      
      this.loading = true;
      try {
        const payload = { ...this.form, id_firma: this.firmaId };
        const res = await axios.post('/api/contabilitate/rj/nota-contabila', payload);
        if (window.toastr) window.toastr.success(res.data.message || 'Notă salvată cu succes.');
        this.$emit('saved');
        this.closeModal();
      } catch (e) {
        console.error('Eroare salvare notă', e);
        const msg = e?.response?.data?.error || e?.response?.data?.message || 'Eroare la salvarea notei contabile.';
        if (window.toastr) window.toastr.error(msg);
        else Swal.fire("Eroare", msg, "error");
      }
      this.loading = false;
    },
    async editNota(id) {
        this.resetForm();
        this.loading = true;
        
        if (this.modalInstance) {
            this.modalInstance.show();
        }

        try {
            const res = await axios.get(`/api/contabilitate/rj/show/${id}`);
            const data = res.data;

            this.form.id = data.id;
            this.form.doc_data = data.doc_data;
            this.form.doc_numar = data.doc_numar;
            
            // Map lines
            this.form.linii = data.linii.map(l => {
                return {
                    explicatie: l.descriere,
                    cont_debit_id: l.cont_debit_id,
                    cont_debit_obj: {
                        id: l.cont_debit_id,
                        cod_complet: l.cont_debit_cod_complet,
                        descriere: l.cont_debit_descriere
                    },
                    cont_credit_id: l.cont_credit_id,
                    cont_credit_obj: {
                        id: l.cont_credit_id,
                        cod_complet: l.cont_credit_cod_complet,
                        descriere: l.cont_credit_descriere
                    },
                    suma_ron: l.suma_ron
                };
            });

        } catch (e) {
            console.error("Eroare la încărcarea notei", e);
            if (window.toastr) window.toastr.error("Nu s-a putut încărca nota contabilă.");
            this.closeModal();
        }
        this.loading = false;
    }
  }
}
</script>

<style scoped>
.required::after {
  content: " *";
  color: red;
}

/* Vue-Multiselect tuning */
.multiselect {
  min-width: 0;
}

:deep(.multiselect__input),
:deep(.multiselect__single),
:deep(.multiselect__tag),
:deep(.multiselect__placeholder),
:deep(.multiselect__content) {
  color: #181C32 !important;
}

:deep(.multiselect__tags) {
  background-color: #fff;
  border: 1px solid #ced4da;
  min-height: 31px;
  padding: 4px 30px 4px 8px;
}

:deep(.multiselect__select) {
  height: 31px;
}

:deep(.multiselect__placeholder) {
  margin-bottom: 0;
  padding-top: 0;
}

/* Stil pentru cont scris mai mic, similar cu UM din facturare */
.small-text-multiselect :deep(.multiselect__single),
.small-text-multiselect :deep(.multiselect__option) {
  font-size: 0.85rem !important;
  white-space: normal !important;
  line-height: 1.25 !important;
}

:deep(.multiselect__content-wrapper) {
  z-index: 1060 !important; /* Above modal */
}

/* Allow multiselect to overflow table cells */
.table-responsive {
  overflow: visible !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
